"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _view = require("../../types/view");
const defaultState = exports.defaultState = {
  active: _view.EActiveView.AuthenticationRegistration
};